import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-payment-term-list',
  templateUrl: './payment-term-list.component.html',
  styleUrls: ['./payment-term-list.component.css']
})
export class PaymentTermListComponent implements OnInit {

  cid: any;
  paymentTermData: any = []
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  first: number = 0;
  tableSize: number = 10;
  deleteClientId: any
  isLoading: any = false
  singlePaymentTermData: any = []
  deletePaymentTermId:any = ""

  paymentTermForm: any | FormGroup;
  searchKey:any = ""

  termTypes = [
    { value: 'HOUR', viewValue: 'Hour' },
    { value: 'DAY', viewValue: 'Day' },
    { value: 'MONTH', viewValue: 'Month' },
    { value: 'YEAR', viewValue: 'Year' }
  ];


  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')

    this.paymentTermForm = this.fb.group({
      termName: ['',[Validators.required]],
      termValue: ['',[Validators.required]],
      termType: ['',[Validators.required]],
    });
    this.getAllPaymentTermWithPagination(this.pageNumber, this.recordsPerPage)
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton3")?.click()
  }


  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.recordsPerPage = event.rows;


    if(this.searchKey != ""){
      this.getAllPaymentTermByWildSearch(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllPaymentTermWithPagination(this.pageNumber,this.recordsPerPage);
    }
  }

  getAllPaymentTermByWildSearch(pageNumber: any,recordsPerPage: any){

    if(this.searchKey != ""){
      this.isLoading = true

      this.generic_service.getAllPaymentTermByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
        
          this.paymentTermData = response.response.paymentTermList
          this.totalRecords = response.response.totalRecords
          this.isLoading = false

        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllPaymentTermWithPagination(this.pageNumber,this.recordsPerPage)
    }

  }

  refreshSearch(){
    this.searchKey = ""
    this.getAllPaymentTermWithPagination(this.pageNumber,this.recordsPerPage)
  }


  getAllPaymentTermWithPagination(pageNumber: any, recordsPerPage: any){
    this.isLoading = true
    this.generic_service.getAllPaymentTermWithPagination(pageNumber,recordsPerPage).subscribe(
      (response:any)=> {
        console.log(response)
        this.paymentTermData = response.response
        this.totalRecords = response.response.totalRecords
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


  getPaymentTermById(paymentTermId:any){
    
    this.generic_service.getPaymentTermById(paymentTermId).subscribe(
      (response:any)=>{
        console.log(response)
        this.singlePaymentTermData = []
        this.singlePaymentTermData.push(response.response)
        this.deletePaymentTermId = response.response.id

        this.paymentTermForm.setValue(
          {
            termName: response.response.termName,
            termValue: response.response.termValue,
            termType: response.response.termType
          }
        );

      },
      (err:any)=> {
        console.log(err)
      }
    )
  }


  editPaymentTerm(){

    if(!this.paymentTermForm.valid){
      this.toastr.error('please fill required fields');

      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.singlePaymentTermData[0].id,
      "paymentTermId": this.singlePaymentTermData[0].paymentTermId,
      "termName": this.paymentTermForm.get('termName').value,
      "termValue": this.paymentTermForm.get('termValue').value,
      "termType": this.paymentTermForm.get('termType').value,
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.editPaymentTerm(body).subscribe(
      (response:any) => {
        console.log(response)
        this.paymentTermForm.reset()
        this.getAllPaymentTermWithPagination(this.pageNumber, this.recordsPerPage)
        this.closeEdit()
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )

  }


  closeEdit() {
    this.paymentTermForm.reset()
  }

  selectPaymentTerm(id:any){
    this.deletePaymentTermId = id
  }

  deletePaymentTerm(){
    this.generic_service.deletePaymentTerm(this.deletePaymentTermId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllPaymentTermWithPagination(this.pageNumber, this.recordsPerPage)
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  addPaymentTerm(){

    if(!this.paymentTermForm.valid){
      this.toastr.error('please fill required fields');

      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "termName": this.paymentTermForm.get('termName').value,
      "termValue": this.paymentTermForm.get('termValue').value,
      "termType": this.paymentTermForm.get('termType').value,
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.addPaymentTerm(body).subscribe(
      (response:any) => {
        console.log(response)
        this.paymentTermForm.reset()
        this.getAllPaymentTermWithPagination(this.pageNumber, this.recordsPerPage)
        this.toastr.success("Successfully Added")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )

  }
 
}
